import { PickPointType, WeekDays } from 'sections/LKSection/shared/PickPointSharedModule/types'
import { BaseOption, Country, ResponseListData } from 'shared/types/types'

import { OrderELockInfoDTO } from '../ELockModule/types'

export type Coordinate = {
  latitude: string
  longitude: string
}

export interface VideoFile {
  url: string
  name: string
  size: number
  binary?: ArrayBuffer
}

export type CreateOrderRequest = {
  phone: number
  cityId: number
  cityName: string
  area: number
  warehouseArea: number
  description: string
  courierWay: string
  dressingRoomsCount: number
  house: string
  street: string
  timetable: string
  latitude: string
  longitude: string
  region: string
  district: string
  actualUrls: string
  country: Country
  locations: PickPointLocation[]
  accessType: CouriersAccess
  cellingHeight: number
  pickPointType: PickPointType
  /** признак переезда */
  exPickPointId?: number
  subsidyHexType?: SubsidyHexType
}

export type UpdateOrderRequest = {
  id: number
  actualUrls?: string
  description?: string
  courierWay?: string
  house?: string
  street?: string
  longitude?: string
  latitude?: string
  timetable?: string
  area?: string
  warehouseArea?: string
  dressingRoomsCount?: string
  cellingHeight?: string
  comment?: string
  pickPointType?: PickPointType
  signboardSize?: SignboardSize
  signboardFormat?: SignboardFormat
  subsidyHexType?: SubsidyHexType
  couriersAccess?: CouriersAccess
  glnPvz?: string
  molName?: string
  ownerGln?: string
}

export enum OrderStatus {
  /** черновик */
  draft = 'ORDER_DRAFT', // 0
  /** новые заявки */
  created = 'ORDER_CREATED', // 1
  /** одобренные заявки */
  accepted = 'ORDER_ACCEPTED', // 2
  /** отмененные заявки */
  canceled = 'ORDER_CANCELED', // 3
  /** Заявка отправлена на доработку из статуса ORDER_PICKPOINT_READY_ACTIVATE (8) */
  remarkFromActivate = 'ORDER_REMARK', // 4
  /** отозванные заявки? */
  declined = 'ORDER_DECLINED', // 5
  /** пвз создан */
  pickPointCreated = 'ORDER_PICKPOINT_CREATED', // 6
  /** Собственник, отправил запрос на активацию. Активация происходит через админку. */
  readyActivate = 'ORDER_PICKPOINT_READY_ACTIVATE', // 8
  /** Заявка на доработке */
  remarkFromCreated = 'ORDER_REMARK_FROM_CREATED', // 9
  /** Заявка удалена */
  deleted = 'ORDER_DELETED', // 9
  /** Ожидает оплату взноса по QR */
  waitingPayment = 'ORDER_WAITING_QR_CODE_PAYMENT', // 11
  /** Взнос по QR не оплачен */
  notPaid = 'ORDER_NOT_PAID_BY_QR_CODE', // 12
  //** Ожидает доработку платежной информации */
  remarkFromPayment = 'ORDER_REMARK_FROM_PAYMENT', // 13
}

export interface OrderCommentDTO {
  comment: string
  dt: string
  sendBy: string
}

export enum PickPointLocation {
  none = 'PICKPOINT_LOCATION_NONE',
  firstLine = 'PICKPOINT_LOCATION_FIRST_LINE',
  inTheYards = 'PICKPOINT_LOCATION_IN_THE_YARDS',
  plinth = 'PICKPOINT_LOCATION_PLINTH',
  shoppingMall = 'PICKPOINT_LOCATION_SHOPPING_MALL',
  secondFloor = 'PICKPOINT_LOCATION_2ND_FLOOR',
  firstFloor = 'PICKPOINT_LOCATION_1ND_FLOOR',
  cellar = 'PICKPOINT_LOCATION_CELLAR',
}

export const enum CouriersAccess {
  none = 'ACCESS_TYPE_NONE',
  night = 'ACCESS_TYPE_NIGHT_ONLY_ACCESS',
  fulltime = 'ACCESS_TYPE_ROUND_THE_CLOCK_ACCESS',
  openingHours = 'ACCESS_TYPE_ONLY_ACCORDING_THE_OPENING_HOURS',
}

export type OrderDTO = {
  cityId: number
  cityName: string
  country: Country
  description: string
  courierWay: string
  house: string
  id: number
  latitude: string
  longitude: string
  status: OrderStatus
  street: string
  timetable: string
  created: string
  updated: string
  deleted?: string
  area: number
  stockArea: number
  cellingHeight: number
  actualUrls: string
  comments: OrderCommentDTO[]
  hasDressRoom: boolean
  dressingRoomsCount: number
  district: string
  region: string
  isBranded: boolean
  locations: PickPointLocation[]
  accessType: CouriersAccess
  tariffDescription?: string
  /** Дата создания заявки. */
  outOfDraftDate?: string | null
  /** признак фирменного ПВЗ */
  wbCompany: boolean
  /** признак переезда */
  exPickpointId: number
  typePoint: PickPointType
  signboardSize: SignboardSize
  signboardFormat: SignboardFormat
  confirmedToOpen: ConfirmedToOpen
  elockInfo: OrderELockInfoDTO | null
  subsidyHexType: SubsidyHexType
  /* 3 поля для Беларуси */
  ownerGln: string
  pickpointGln: string
  molName: string
  /** Внешний ID ПВЗ который будет создан при активации заявки. */
  pickpointId?: number
}

export interface GetTariffsRequest {
  lat: number
  lon: number
  area: number
  typePoint: PickPointType
}

export type GetTariffDTO = {
  tariff: number
  tariffDescription: string
  typePoint: PickPointType
  reward: number
  profit: number
}

export type PublishOrderDTO = ResponseListData<true> & {
  status: OrderStatus
}

export type AddOrderPaymentDTO = ResponseListData<{
  sumRub: string
  currency: Country
}> & {
  paymentUrl: string
}

export type AddOrderPayment = ResponseListData<{
  sum: string
  country: Country
}> & {
  paymentUrl: string
}

export enum OrderPaymentStatus {
  none = 'CHECK_STATUS_NONE',
  /**  Оплата не прошла. Ошибка */
  error = 'CHECK_STATUS_ERROR',
  /** Оплата успешно проведена */
  paid = 'CHECK_STATUS_PAID',
  /** Транзакция находится в обработке. Необходимо перезапросить информацию повторно */
  //pending = 'CHECK_STATUS_PENDING',
  /** Косячное название на беке. Транзакция находится в обработке. Необходимо перезапросить информацию повторно */
  pending = 'PickpointOrderCheckStatusNotPaid',
}

export type OrderInitialStateType = {
  description: string
  courierWay: string
  lat: string
  lng: string
  area: string | null
  timetableStart: string
  timetableEnd: string
  timetableGeneral: string
  weekDays: WeekDays[]
  warehouseArea: string | null
  dressingRoomsCount: string | null
  cellingHeight: string | null
  videos: string[]
  documents: string[]
  photos: {
    url: string
    isPublic: boolean
  }[]
  comment: string
  typePointItem: PickPointType | null
  subsidyTypeItem: BaseOption<SubsidyHexType> | null
  couriersAccess: CouriersAccess
}

export type OrderMessageDTO = {
  createdAt: string
  fileUrl: string[]
  id: number
  message: string
  pickpointOrderId: number
  sentBy: number
}

type CCTVBaseInfo = {
  url: string
  login: string
  password: string
  description: string
}

export type AddCCTVInfoRequest = CCTVBaseInfo & {
  orderId: number
}

export type ValidateCCTVInfoRequest = CCTVBaseInfo & {
  token: string | null
  vendor: number
  externalPickPointId: number
}

export type Cameras = {
  idCamera: string
  name: string
  limitDays: number
  status: number
  archAvailability: boolean
}

export type ValidateCCTVInfoDTO = {
  externalPickpointId: number
  isValidated: true
  cameraCheck: true
  statusCheck: true
  archiveCheck: true
  cameras: Cameras[]
}

export type CCTVInfoDTO = {
  id: number
  url: string
  login: string
  password: string
  description: string
  created: string
  updated: string
  pickpointId: number
  pickpointOrderId: number
  status: AuthorizationState
}

export type VendorList = {
  id: number
  name: string
  hasToken: boolean
}

export type CameraVendorListDTO = {
  vendor_list: VendorList[]
}

export enum AuthorizationState {
  loading,
  success,
  failed,
}

export enum SignboardSize {
  none = 'SIGNBOARD_SIZE_NONE',
  mini = 'SIGNBOARD_SIZE_MINI',
  small = 'SIGNBOARD_SIZE_SMALL', //300
  middle = 'SIGNBOARD_SIZE_MIDDLE', //400
  big = 'SIGNBOARD_SIZE_BIG', //500
}

export enum SignboardFormat {
  none = 'SIGNBOARD_FORMAT_NONE',
  old = 'SIGNBOARD_FORMAT_OLD',
  new = 'SIGNBOARD_FORMAT_NEW',
}

export enum ConfirmedToOpen {
  none = 'none',
  true = 'true',
  false = 'false',
}

export type CheckOrderAddressRequest = {
  cityId: string
  cityName: string
  region: string
  country: Country
  house: string
  street: string
  coordinates: {
    latitude: number
    longitude: number
  }
}

export enum FurnitureOrderType {
  none = 'FURNITURE_ORDER_SCHEME_UNKNOWN',
  auto = 'FURNITURE_ORDER_SCHEME_AUTO',
  self = 'FURNITURE_ORDER_SCHEME_SELF',
}

export enum SubsidyHexType {
  none = 'SUBSIDY_HEX_TYPE_NONE',
  single = 'SUBSIDY_HEX_TYPE_SINGLE',
  guaranteedIncome = 'SUBSIDY_HEX_TYPE_GUARANTEED_INCOME',
  singleAfterActivation = 'SUBSIDY_HEX_TYPE_SINGLE_AFTER_ACTIVATION',
}

export type SubsidyTypeDTO = {
  subsidy_info: SubsidyInfo[]
}

export type SubsidyInfo = {
  subsidy: number
  subsidyType: SubsidyHexType
}

export type GetPaymentDeadlineDTO = {
  time_remaining: {
    seconds: number
  }
}

export type PwaEventType = { prompt: () => Promise<void> }

export type OrderReadyActivateRequest = {
  orderId: number
  ownerGln?: string
  glnPvz?: string
  molName?: string
}
